module.exports = __webpack_public_path__ + "static/img/rechargeList.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/rechargeList.png
// module id = 584
// module chunks = 0